import {
  ApiBlueprint,
  configApiRef,
  discoveryApiRef,
  githubAuthApiRef,
  oauthRequestApiRef,
} from '@backstage/frontend-plugin-api';
import { GithubAuth } from '@backstage/core-app-api';

// Same extension id as plugin-app's default (`api:app/github-auth`), so this
// shadows it. Only difference from upstream is `defaultScopes`: without
// `user:email` GitHub omits the email from the returned profile and the
// emailMatchingUserEntityProfileEmail sign-in resolver in
// app-config.local.yaml can't match the user.
//
// scmIntegrations, ScmAuth and toastApi all come from plugin-app's defaults;
// we no longer register them here.
export const githubAuthApi = ApiBlueprint.make({
  name: 'github-auth',
  params: defineParams =>
    defineParams({
      api: githubAuthApiRef,
      deps: {
        configApi: configApiRef,
        discoveryApi: discoveryApiRef,
        oauthRequestApi: oauthRequestApiRef,
      },
      factory: ({ configApi, discoveryApi, oauthRequestApi }) =>
        GithubAuth.create({
          configApi,
          discoveryApi,
          oauthRequestApi,
          defaultScopes: ['read:user', 'user:email'],
        }),
    }),
});
